import { render, staticRenderFns } from "./tjjl.vue?vue&type=template&id=04106534&scoped=true"
import script from "./tjjl.vue?vue&type=script&lang=js"
export * from "./tjjl.vue?vue&type=script&lang=js"
import style0 from "./tjjl.vue?vue&type=style&index=0&id=04106534&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04106534",
  null
  
)

export default component.exports